import { abrePDF } from "../../utils/pdf";
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Table, Label, Input, Button } from "reactstrap";
import axios from "axios";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Header from "../../layout/Header/Header";

function EstadoCuentaCXP() {
  const { user } = useContext(AuthContext);
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;

  const hoy = moment().format("YYYY-MM-DD");
  const ini = moment().subtract(180, "days").format("YYYY-MM-DD");

  const [fechaInicio, setFechaInicio] = useState(ini);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [notas, setNotas] = useState([]);

  useEffect(() => {
    axios
      .get(URL_PROVEEDORES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setProveedores(r.data || []))
      .catch(() => setProveedores([]));
  }, [URL_PROVEEDORES]);

  async function cargar() {
    if (!selectedProveedor) return;
    try {
      const [resNC, resAb] = await Promise.all([
        axios.get(URL_NOTAS_CXP, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }),
        axios.get(URL_ABONOS_PROVEEDORES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }),
      ]);
      const ncProv = (resNC.data || []).filter(
        (n) => n.is_active !== "No" && n.proveedores?.[0]?._id === selectedProveedor
      );
      const abonos = (resAb.data || []).filter((a) => a.notasCxP);
      const rows = ncProv.map((n) => {
        const abs = abonos.filter((a) => (a.notasCxP?._id || a.notasCxP) === n._id);
        const totalAb = abs.reduce((s, a) => s + Number(a.importe || 0), 0);
        return {
          _id: n._id,
          numero: n.idNotaCxP,
          fecha: n.fecha,
          embarque: n.embarques?.[0]?.contenedor || "",
          total: Number(n.total_costo || 0),
          abonos: totalAb,
          saldo: Number(n.saldo || (n.total_costo - totalAb)),
        };
      }).filter((r) => (!fechaInicio || r.fecha >= fechaInicio) && (!fechaFin || r.fecha <= fechaFin));
      setNotas(rows);
    } catch (err) { console.log(err); }
  }

  useEffect(() => { if (selectedProveedor) cargar(); /* eslint-disable-next-line */ }, [selectedProveedor, fechaInicio, fechaFin]);

  function pdf() {
    const prov = proveedores.find((p) => p._id === selectedProveedor);
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Estado de Cuenta CxP", 14, 18);
    doc.setFontSize(10);
    doc.text(`Proveedor: ${prov?.nombre_comercial || ""}`, 14, 26);
    doc.text(`Periodo: ${fechaInicio} - ${fechaFin}`, 14, 32);
    const body = notas.map((n) => [
      n.numero, n.fecha, n.embarque,
      `$${n.total.toFixed(2)}`,
      `$${n.abonos.toFixed(2)}`,
      `$${n.saldo.toFixed(2)}`,
    ]);
    const tot = notas.reduce((s, n) => s + n.total, 0);
    const ab = notas.reduce((s, n) => s + n.abonos, 0);
    const sa = notas.reduce((s, n) => s + n.saldo, 0);
    doc.autoTable({
      head: [["Venta", "Fecha", "Embarque", "Total", "Abonos", "Saldo"]],
      body,
      foot: [["", "", "TOTALES", `$${tot.toFixed(2)}`, `$${ab.toFixed(2)}`, `$${sa.toFixed(2)}`]],
      startY: 38, theme: "grid", styles: { fontSize: 9 },
      headStyles: { fillColor: [176, 35, 7] },
    });
    abrePDF(doc, `EdoCta-CxP-${prov?.nombre_comercial || "proveedor"}.pdf`);
  }

  const totales = notas.reduce(
    (s, n) => ({ total: s.total + n.total, abonos: s.abonos + n.abonos, saldo: s.saldo + n.saldo }),
    { total: 0, abonos: 0, saldo: 0 }
  );

  return (
    <>
      <Header />
      <div className="container">
        <h3 align="center">Estado de Cuenta CxP (por NotaCxP)</h3>
        <Row>
          <Col md={3}>
            <Label>Proveedor</Label>
            <Input type="select" value={selectedProveedor} onChange={(e) => setSelectedProveedor(e.target.value)}>
              <option value="">Selecciona</option>
              {proveedores
                .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                .map((p) => (
                  <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                ))}
            </Input>
          </Col>
          <Col md={2}>
            <Label>Desde</Label>
            <Input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
          </Col>
          <Col md={2}>
            <Label>Hasta</Label>
            <Input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
          </Col>
          <Col md={2} style={{ display: "flex", alignItems: "flex-end" }}>
            <Button color="danger" onClick={pdf} disabled={!selectedProveedor}>
              PDF <i className="far fa-file-pdf"></i>
            </Button>
          </Col>
        </Row>
        <br />
        <Table size="sm" striped bordered>
          <thead>
            <tr>
              <th>Nota</th><th>Fecha</th><th>Embarque</th><th>Total</th><th>Abonos</th><th>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {notas.map((n) => (
              <tr key={n._id}>
                <td>{n.numero}</td>
                <td>{n.fecha}</td>
                <td>{n.embarque}</td>
                <td>${n.total.toFixed(2)}</td>
                <td>${n.abonos.toFixed(2)}</td>
                <td>${n.saldo.toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: "bold" }}>
              <td colSpan={3}>TOTALES</td>
              <td>${totales.total.toFixed(2)}</td>
              <td>${totales.abonos.toFixed(2)}</td>
              <td>${totales.saldo.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default EstadoCuentaCXP;
